import { FC } from 'react';
import styled from '@emotion/styled';
import { WHITE_LABEL } from '../constants';

const Container = styled.div`
  padding: 40px;
  max-width: 800px;
  margin: 0 auto;
  color: white;
  line-height: 1.6;
  font-family: sans-serif;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 24px;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  margin-top: 32px;
  margin-bottom: 16px;
`;

const Paragraph = styled.p`
  margin-bottom: 16px;
`;

export const PublicOffer: FC = () => {
  if (WHITE_LABEL) {
    return (
      <Container>
        <Title>Public Offer</Title>
        <Paragraph>
          This document is a public offer for the use of the PLAYER platform.
        </Paragraph>
        <SectionTitle>1. General Provisions</SectionTitle>
        <Paragraph>
          1.1. This agreement defines the terms of use of the services provided by the platform.
        </Paragraph>
        <SectionTitle>2. Terms of Use</SectionTitle>
        <Paragraph>
          2.1. The user agrees to use the platform in accordance with the current legislation.
        </Paragraph>
        <Paragraph>
          2.2. The platform provider reserves the right to modify the terms of this offer at any time.
        </Paragraph>
        {/* Add more generic sections as needed */}
      </Container>
    );
  }

  return (
    <Container>
      <Title>Публичная оферта (Plai)</Title>
      <Paragraph>
        Настоящий документ является публичной офертой сервиса Plai.
      </Paragraph>
      <SectionTitle>1. Общие положения</SectionTitle>
      <Paragraph>
        1.1. Данное соглашение определяет условия использования сервисов, предоставляемых платформой Plai.
      </Paragraph>
      <SectionTitle>2. Условия использования</SectionTitle>
      <Paragraph>
        2.1. Пользователь соглашается использовать платформу в соответствии с действующим законодательством.
      </Paragraph>
      <Paragraph>
        2.2. Администрация Plai оставляет за собой право изменять условия данной оферты в любое время.
      </Paragraph>
    </Container>
  );
};
